export default Object.freeze({
  UNAUTHORIZED: 'unauthorized',
  LOGOUT: 'logout',
  DIALOG: 'dialog',
  ORDER_GROUP_DELETE: 'order_group_delete',
  ORDER_GROUP_NAME_MODIFY: 'order_group_name_modify',
  ORDER_PLAN_DELETE: 'order_plan_delete',
  ORDER_PLAN_NAME_MODIFY: 'order_plan_name_modify'
});
